import React from 'react';
import { Utils } from '../../services';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import i18n from "i18next";

const ActivitiesField = ({ activities, single, name, ...rest }) => {

    if (!activities)
        return null;

    const ui_lang = Utils.i18nUiLang(i18n);

    const options = activities.sort((a, b) => {
        return Utils.localized_or_fallback(a.fullname, ui_lang).localeCompare(
            Utils.localized_or_fallback(b.fullname, ui_lang)
        );
    }).map((activity) => ({
        key: activity.id,
        text: Utils.localized_or_fallback(activity.name, ui_lang),
        value: activity.id
    }));

    return single ? (
        <SelectField name={ name } options={ options } {...rest} />
    ) : (
        <MultiSelectField name={ name } options={ options } {...rest} />
    );
}

export default ActivitiesField;
